import Vue from 'vue'
import { Tabs, Form, Input, Select, Button, Icon, message, Spin } from 'ant-design-vue'
import Storage from 'vue-ls'
import SliderCaptcha from '@/components/slider-captcha'
import VerificationCode from '@/components/verification-code'
import MobileInput from '@/components/mobile-input'
import UserIcon from '@/components/icon'

import './css/index.less'

Vue.config.productionTip = false
Vue.use(Storage)
Vue.use(Tabs)
Vue.use(Form)
Vue.use(Input)
Vue.use(Select)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Spin)
Vue.use(UserIcon)
Vue.use(SliderCaptcha)
Vue.use(VerificationCode)
Vue.use(MobileInput)
Vue.prototype.$message = message
